module.exports = __webpack_public_path__ + "static/media/icon.69f3d863.svg";